import React, { useMemo } from 'react'
import { Image } from 'antd';
import WeddingSection from './WeddingSection';
import thankYouImage from "components/WeddingAlbum/album/08_TIT08020.jpg"
import AnimationIn from 'components/AnimationIn';

const thankYouMessage = {
"vuquy": `Thật hạnh phúc khi có {{customer_address_term}} ở bên và chung vui cùng {{self_pronoun}} trong một khoảnh khắc rất thiêng liêng của gia đình.
Lễ Vu Quy không chỉ là ngày cô dâu rời vòng tay gia đình mình lớn lên, mà còn là lời cảm ơn dành cho những yêu thương đã nuôi dưỡng và chở che.
Sự hiện diện của {{customer_address_term}} là niềm ấm áp, là sự sẻ chia, giúp khoảnh khắc ấy trở nên trọn vẹn và đầy ý nghĩa hơn bao giờ hết.`,
"thanhhon": `Thật hạnh phúc khi có {{customer_address_term}} đồng hành và chung vui cùng {{self_pronoun}} trong ngày {{self_pronoun}} chính thức bắt đầu một chặng đường mới.
Lễ Thành Hôn là dấu mốc của sự lựa chọn, khi hai con người quyết định gắn bó, cùng nhau xây dựng một mái ấm bằng yêu thương và thấu hiểu.
Sự hiện diện của {{customer_address_term}} không chỉ là niềm vinh dự, mà còn là món quà quý giá góp phần làm cho ngày hôm ấy trở nên trọn vẹn và đáng nhớ hơn.`,
"both": `Thật hạnh phúc khi có {{customer_address_term}} ở bên và chứng kiến cả hai khoảnh khắc quan trọng trong hành trình của {{self_pronoun}}.
Từ Lễ Vu Quy - nơi yêu thương được trao gửi, đến Lễ Thành Hôn - nơi một mái ấm mới bắt đầu, mỗi khoảnh khắc đều mang ý nghĩa rất riêng và trở nên trọn vẹn hơn khi có sự hiện diện của {{customer_address_term}}.
Cảm ơn {{customer_address_term}} vì đã dành thời gian, tình cảm và cùng {{self_pronoun}} lưu giữ những kỷ niệm đẹp của ngày hôm nay.`,
}

export default function ThankYouSection({ invitation }) {
    const customer_address_term = invitation?.data?.customer_address_term?.toLowerCase() || "bạn";
    const self_pronoun = invitation?.data?.self_pronoun?.toLowerCase() || "chúng mình";
    const messageKey = (!invitation || invitation?.data?.both_tab === 1 ? "both"
    : invitation?.place?.tab === "hanoi" ? "vuquy"
    : "thanhhon");

    const message = useMemo(() => {
        return thankYouMessage[messageKey]
        .replaceAll("{{customer_address_term}}", customer_address_term)
        .replaceAll("{{self_pronoun}}", self_pronoun)
    }, [messageKey])

    return (
        <WeddingSection>
            <div
                className='no-wedding-padding-x no-wedding-padding-y'
                style={{
                    // textAlign: 'center',
                    // position: "relative",
                    // marginTop: "20px"
                    position: "relative",
                }}>
                <div style={{ position: "relative" }}>
                    <Image alt="thankyou_bg" src={thankYouImage} width="100%" preview={false}
                        style={{
                            // height: "100vh",
                            // objectFit: "cover",
                            // objectPosition: "120% center",
                        }} />
                    <div style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#00000075",
                        // backgroundColor: "#47451e50",
                        pointerEvents: "none",
                    }} />

                    <div style={{
                        position: "absolute",
                        top: "80%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                    }}>

                        <AnimationIn animationName="fadeUp">
                            <div
                                style={{
                                    textAlign: "center",
                                    fontFamily: "'Birthstone', cursive",
                                    fontStyle: "italic",
                                    fontSize: "50px",
                                    color: "white",
                                    letterSpacing: "2px",
                                    whiteSpace: "nowrap",
                                    textShadow: "2px 2px 5px rgba(0,0,0,0.5)",
                                }}>
                                Thank you!
                            </div>
                        </AnimationIn>
                    </div>
                </div>
                <div style={{
                    position: "absolute",
                    top: "10%",
                    left: "20%",
                    transform: "translate(-10%, -0%)",
                }}>
                    <AnimationIn animationName="fadeUp">
                        <div
                            style={{
                                textAlign: "center",
                                fontFamily: "'Crimson Text', serif",
                                color: "white",
                                fontSize: "14px",
                            }}>
                            <div style={{ 
                                whiteSpace: "pre-line",
                                textShadow: "2px 2px 5px rgba(0,0,0,0.5)",
                            }}>
                                {message}
                            </div>
                        </div>
                    </AnimationIn>
                </div>

            </div>
        </WeddingSection>
    )
}
